module.exports = "static/assets/c73619fea5bb43c53a080399a35273be.png";